import React from "react";
import { colors } from "../../../../styles/colors";
import GenericButton from "./GenericButton";

const backgroundColor = {
    normal: colors.transparent,
    pressed: colors.secondaryHighlighted,
    disabled: colors.transparent
}

const contentColor = {
    normal: colors.primaryHighlighted,
    pressed: colors.primaryHighlighted,
    disabled: colors.disabledHighlighted,
}

export default function TertiaryButton({ children, size, rightIcon, leftIcon, ...props }) {
    return (
        <GenericButton
            {...props}
            size={size}
            rightIcon={rightIcon}
            leftIcon={leftIcon}
            backgroundColor={backgroundColor.normal}
            pressedBackgroundColor={backgroundColor.pressed}
            disabledBackgroundColor={backgroundColor.disabled}
            contentColor={contentColor.normal}
            pressedContentColor={contentColor.pressed}
            disabledContentColor={contentColor.disabled}
        >
            {children}
        </GenericButton>
    );
}
